import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACTIVITY_LOG_SELECT_MAP, ACTIVITY_LOG_SELECT_MAP_REVERSED, ACTIVITY_LOG_STATUS, ACTIVITY_LOG_USER_EVENT_MAP, ACTIVITY_LOG_USER_EVENT_MAP_REVERSED, PAGESIZE_ACTIVITY_LOG,PARTIAL_SUCCESS, TMX_FAILURE } from "../../shared/Constants";
import Input from "../../UI/Input/Input";
import Button from "../../UI/Button/Button";
import { activitySearch, isActivitySearched, setError} from "../../store/actions";
import  classes  from "./ActivityLogResult.css";
import {checkValidity, getPortalDisplayName, isValidJson } from "../../shared/utility";
import Message from "../../components/Message/Message";
import ActivityLogPaginationBtns from "./ActivityLogPaginationBtns";
import { activitySearchSetPageNumber} from "../../store/actions/agentActivity";
import BootstrapTable from "react-bootstrap-table-next";
import Spinner from "../../UI/Spinner/Spinner";
import ReactTooltip from 'react-tooltip';
import ActivityLogResultDisplayBox from "./ActivityLogResultDisplayBox";
import UserSearchBlock from "./UserSearchBlock";
import moment from "moment-timezone";

const returnResultMapping = (eventType) => {
    if(eventType === 'USER'){
        return [
            {dataField: 'event', text: 'Event'},
            {dataField: 'firstName', text: 'First Name'},
            {dataField: 'lastName', text: 'Last Name'}, 
            {dataField: 'dob', text: 'DOB'}, 
            {dataField: 'eventStatus', text: 'Status'},
            {dataField: 'failureReason', text: 'Failure Reason'},
            {dataField: 'username', text: "UserName"},
            {dataField: 'uuid', text: "UUID"},
            {dataField: 'newDeviceDetailsEvent', text: 'New Device Details'},
            {dataField: 'eventTimestamp', text: 'Timestamp'},
            {dataField: 'targetPortal', text: 'Target Portal'},
        ]
    } else if(eventType === 'ALL'){
        return [
            {dataField: 'eventTimestamp', text: 'Timestamp'},
            {dataField: 'targetPortal', text: 'Target Portal'},
            {dataField: 'username', text: "UserName"},
            {dataField: 'agentId', text: 'AgentID'},
            {dataField: 'event', text: 'Event'},
            {dataField: 'oldData', text: 'Old Data'},
            {dataField: 'newData', text: 'New Data'},
            {dataField: 'eventStatus', text: 'Status'},
            {dataField: 'failureReason', text: 'Failure Reason'},
            {dataField: 'firstName', text: 'First Name'},
            {dataField: 'lastName', text: 'Last Name'}, 
            {dataField: 'uuid', text: "UUID"}
        ]
    } else{
        return [
            {dataField: 'event', text: 'Event'},
            {dataField: 'oldData', text: 'Old Data'},
            {dataField: 'newData', text: 'New Data'}, 
            {dataField: 'eventStatus', text: 'Status'},
            {dataField: 'failureReason', text: 'Failure Reason'},
            {dataField: 'username', text: "UserName"},
            {dataField: 'uuid', text: "UUID"},
            {dataField: 'eventTimestamp', text: 'Timestamp'},
            {dataField: 'agentId', text: 'AgentID'}
        ]
    }
}

const getTimestamp=(time)=>{
    const inputTime = moment.utc(time);
    const referenceTime = moment(1750914331271); // This is a reference time after which cutover happened
    let result;
    if(inputTime.isAfter(referenceTime)){
        result = inputTime.clone().tz('America/Chicago'); // Convert to Central Time Zone
    } else {
        result = inputTime
    }
    return result.format('YYYY-MM-DDTHH:mm:ss:SSS');
}

const getActivitiesList = (eventType, activities) => {
    let activityListNew = [];
    if(eventType === 'USER'){
        for(let i =0; i<activities.length; i++){
            let newActivity = {...activities[i]};
            let deviceType = ((newActivity.metaData?.device?.type !== undefined) && (newActivity.metaData?.device?.type !== null)) ? newActivity.metaData?.device?.type : "";
            let locationCity = ((newActivity.metaData?.device?.location?.city !== undefined)&& (newActivity.metaData?.device?.location?.city !== null)) ? newActivity.metaData?.device?.location?.city : "";
            let locationState = ((newActivity.metaData?.device?.location?.state !== undefined)&& (newActivity.metaData?.device?.location?.state !== null)) ? newActivity.metaData?.device?.location?.state : "";
            let deviceLocation = (deviceType !== "" || locationCity !== "" || locationState !== "") ? deviceType+", "+locationCity+", "+locationState : "";
            newActivity["id"] = i;
            newActivity.username = newActivity.username === "NA" || newActivity.username === "na" || newActivity.username == null ? "-" : newActivity.username
            newActivity.uuid = (newActivity.uuid === "NA" || newActivity.uuid == null)? "-" : newActivity.uuid
            newActivity.firstName = newActivity.firstName == null || newActivity.firstName === "NA" ? "-" : newActivity.firstName
            newActivity.lastName = newActivity.lastName == null || newActivity.lastName === "NA" ? "-" : newActivity.lastName
            newActivity.dob = newActivity.dob == null || newActivity.dob === "NA" ? "-" : newActivity.dob
            newActivity.failureReason = newActivity.failureReason == null ? "-" : JSON.stringify(newActivity.failureReason).replace(/(\\n)/g,'')
            .replace(/["{}\\]/g,'').split(",").map(fr => <p key={fr}>{fr}</p>)       
            newActivity.eventStatus = (newActivity.eventStatus === PARTIAL_SUCCESS )? <p data-tip="All updates are not successful. Few updates are failed.">{newActivity.eventStatus}</p> : newActivity.eventStatus
            newActivity.targetPortal = (newActivity.metaData?.targetPortal === "NA" || newActivity.metaData?.targetPortal == null) ? "-": getPortalDisplayName(newActivity.metaData?.targetPortal)
            newActivity.event = ACTIVITY_LOG_USER_EVENT_MAP_REVERSED[newActivity.event]?ACTIVITY_LOG_USER_EVENT_MAP_REVERSED[newActivity.event].name:newActivity.event
            newActivity.newDeviceDetailsEvent = (deviceLocation === "") ? "-" : deviceLocation;
            newActivity.eventTimestamp = getTimestamp(newActivity.eventTimestamp)
            activityListNew.push(newActivity);
        } 
    }else{
        for(let i =0; i<activities.length; i++){
            let newActivity = {...activities[i]}
            const failureReason = newActivity.event === 'PHONE_BASED_ID_CONFIRMATION' && newActivity.eventStatus === 'TMX_FAILURE' ?  
            ([newActivity.failureReason ,
            'Fullname: ' + (newActivity.metaData?.FullName ?? '-'),
            'Address: ' + (newActivity.metaData?.Address ?? '-')].map((reason)=><p>{reason}</p>))
            : ( newActivity.failureReason?.indexOf('{') >-1 ? JSON.stringify(newActivity.failureReason).replace(/(\\n)/g,'')
            .replace(/["{}\\]/g,'').split(",").map(fr => <p key={fr}>{fr}</p>) : newActivity.failureReason);

            const oldData = newActivity.event === 'PHONE_BASED_ID_CONFIRMATION' ? 
            ( [newActivity.oldData,
            ].map((old, i)=>i===0 ? (JSON.stringify(Object.assign({
                ...(newActivity.oldData['First Name'] ? {'First Name': newActivity.oldData['First Name']} :{}),
                ...(newActivity.oldData['Last Name'] ? {'Last Name': newActivity.oldData['Last Name']} :{})
            }, newActivity.oldData ?? {})) ?? '')
            .replace(/["{}]/g, '').split(",").map(old => <p key={old}>{old}</p>) :  <p>{old}</p>))  : 
            JSON.stringify(newActivity.oldData ?? {})
                .replace(/["{}]/g, '').split(",").map(old => <p key={old}>{old}</p>)

            newActivity["id"] = i;
            newActivity.username = newActivity.username === "NA" || newActivity.username === "na" || newActivity.username == null ? "-" : newActivity.username
            newActivity.agentId = (newActivity.agentId === "NA" || newActivity.agentId == null) ? "-":newActivity.agentId
            newActivity.uuid = (newActivity.uuid === "NA" || newActivity.uuid == null)? "-" : newActivity.uuid
            newActivity.oldData = (newActivity.oldData == null || newActivity.oldData["NA"] === "NA") ? "-" : oldData
            newActivity.newData = newActivity.newData == null || newActivity.newData["NA"] === "NA" ? "-" : JSON.stringify(newActivity.newData)
                .replace(/["{}]/g, '').split(",").map(newd => <p key={newd}>{newd}</p>)
            newActivity.failureReason = (!newActivity.failureReason || newActivity.failureReason == null) ? "-" : failureReason           
            newActivity.event = ACTIVITY_LOG_SELECT_MAP_REVERSED[newActivity.event]?ACTIVITY_LOG_SELECT_MAP_REVERSED[newActivity.event].name:newActivity.event
            newActivity.eventStatus = (newActivity.eventStatus === "NA" || newActivity.eventStatus == null)?"-":(newActivity.eventStatus === PARTIAL_SUCCESS )? <p data-tip="All updates are not successful. Few updates are failed.">{newActivity.eventStatus}</p> : newActivity.eventStatus
            newActivity.eventTimestamp = getTimestamp(newActivity.eventTimestamp)
            newActivity.targetPortal = (newActivity.metaData?.targetPortal === "NA" || newActivity.metaData?.targetPortal == null) ? "-": getPortalDisplayName(newActivity.metaData?.targetPortal)
            activityListNew.push(newActivity)
        } 
    }
    return activityListNew
}

const getEventDisplayName = (eventValue) => {
    if (!eventValue) {
        return 'Select One';
    }
    const mappedEvent = ACTIVITY_LOG_SELECT_MAP_REVERSED[eventValue] || ACTIVITY_LOG_USER_EVENT_MAP_REVERSED[eventValue];
    return mappedEvent ? mappedEvent.name : 'Select One';
}

const ActivityLogResults = (props) => {

    const dispatch = useDispatch()

    const errorMsg = useSelector(state => state.agentActivity.error)
    const activityList = useSelector(state => state.agentActivity.activities)
    const showSpinner = useSelector(state => state.agentActivity.showSpinner)
    const hideResult = useSelector(state => state.agentActivity.hideResult);
    
    const [activities, setActivities] = useState([])
    const [firstName, setFirstName] = useState({value: props.activityResultSearch?.firstName ?? '', touched: !!props.activityResultSearch?.firstName})
    const [lastName, setLastName] = useState({value: props.activityResultSearch?.lastName ?? '', touched: !!props.activityResultSearch?.lastName})
    const [dob, setDOB] = useState({value: props.activityResultSearch?.dob ?? '', touched: !!props.activityResultSearch?.dob})

const getStatusOptions=(value)=>{
    const arr = ACTIVITY_LOG_STATUS.map(
        status => ({
            "disabled": false,
            "value": status,
            "displayValue": status
        })
    )
    if(value==='PHONE_BASED_ID_CONFIRMATION') {
        arr.push({
            "disabled": false,
            "value": TMX_FAILURE,
            "displayValue": TMX_FAILURE
        })
    }
    return arr;
}
    const clearUserSearch = useRef(null)
    const [formInputElements, setFormInputElements] = useState({
        event: {
            elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'event',
                    placeholder: '',
                    options: props.eventList,
                },
                value: getEventDisplayName(props.activityResultSearch?.event),
                validation: {
                    required: false
                },
                valid: true,
                touched: false,
                label: "Event",
                inputType: "Quarter"
        },
        eventStatus:{
            elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'eventStatus',
                    placeholder: '',
                    options: getStatusOptions(props.activityResultSearch?.event)
                },
                value: props.activityResultSearch?.eventStatus || 'Select One',
                validation: {
                    required: false
                },
                valid: true,
                touched: false,
                label: "Status",
                inputType: "Quarter"
        },
        username:{
            elementType: 'input',
            elementConfig: {
                type: 'text',
                id: 'username',
                placeholder: '',
                title: 'User Name'
            },
            value: props.activityResultSearch?.username ?? '',
            validation: {
                required: false,
                minlength: 2
            },
            valid: true,
            touched: false,
            label: "User Name",
            inputType: "Quarter"
        },
        uuid:{
            elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'uuid',
                    placeholder: '',
                    maxLength: 101
                },
                value: props.activityResultSearch?.uuid ?? '',
                validation: {
                    required: false,
                    minlength: 2,
                    maxlength: 100,
                    nospace: true,
                },
                valid: true,
                touched: false,
                label: "UUID",
                inputType: "Quarter"
        }
    })

    useEffect(() => {
            setActivities(activityList.events)
    }, [activityList])

    /*
        The form above is seeded from props only on the first render. When the results
        screen is opened directly from a restored search, the executed request and the
        event list arrive on a later render, so untouched fields are re-synced here.
    */
    useEffect(() => {
        const executedSearch = props.activityResultSearch || {};
        setFormInputElements(currentForm => {
            const syncedValue = (field, value) => currentForm[field].touched ? currentForm[field].value : value;
            return {
                ...currentForm,
                event: {
                    ...currentForm.event,
                    elementConfig: {...currentForm.event.elementConfig, options: props.eventList},
                    value: syncedValue('event', getEventDisplayName(executedSearch.event))
                },
                eventStatus: {
                    ...currentForm.eventStatus,
                    elementConfig: {...currentForm.eventStatus.elementConfig, options: getStatusOptions(executedSearch.event)},
                    value: syncedValue('eventStatus', executedSearch.eventStatus || 'Select One')
                },
                username: {
                    ...currentForm.username,
                    value: syncedValue('username', executedSearch.username ?? '')
                },
                uuid: {
                    ...currentForm.uuid,
                    value: syncedValue('uuid', executedSearch.uuid ?? '')
                }
            };
        });

        !firstName.touched && setFirstName({value: executedSearch.firstName ?? '', touched: false});
        !lastName.touched && setLastName({value: executedSearch.lastName ?? '', touched: false});
        !dob.touched && setDOB({value: executedSearch.dob ?? '', touched: false});
    }, [props.eventList, props.activityResultSearch])

    const [formIsValid, setFormIsValid] = useState(true);
    const formHeader = "Activity Logs"
    const errorHandler = (error) => {
        dispatch(setError(error))
    }

    const isSearchButtonDisabled = () => {
        return formIsValid
    }

    const clearSearch = () => {
        /*
            Every field shown on this form is cleared, not just the touched ones, so the
            executed request stays in step with the form. Leaving untouched values behind
            would let the prop sync effect below repopulate the fields again.
        */
        let formData = {...props.activityResultSearch}
        for(let formElementIdentifier in formInputElements){
            const key = formInputElements[formElementIdentifier].elementConfig.id
            formData[key] = ''
        }
        formData['firstName'] = ''
        formData['lastName'] = ''
        formData['dob'] = ''
        props.setActivityResultSearch(formData)
        const updatedForm = {...formInputElements}

        updatedForm['event'].value = 'Select One'
        updatedForm['eventStatus'].value = 'Select One'
        updatedForm['eventStatus'].elementConfig.options = getStatusOptions('')
        updatedForm['username'].value = ''
        updatedForm['uuid'].value = ''

        updatedForm['event'].valid = true
        updatedForm['eventStatus'].valid = true
        updatedForm['username'].valid = true
        updatedForm['uuid'].valid = true

        updatedForm['event'].touched = false
        updatedForm['eventStatus'].touched = false
        updatedForm['username'].touched = false
        updatedForm['uuid'].touched = false

        setFirstName({value: '', touched: false})
        setLastName({value: '', touched: false})
        setDOB({value: '', touched: false})
        if(clearUserSearch.current){
            clearUserSearch.current()
        }        

        setFormInputElements(updatedForm)
        dispatch(setError(null))
        
        setFormIsValid(true)
    }

    const inputChangedHandler = (eventReceived, inputIdentifier) => {

        let updatedForm = {...formInputElements};

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = eventReceived.target.value;

        if(eventReceived.target.value) {
            const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.valid = validation.isValid;
            errorHandler({message: validation.message});
            if(inputIdentifier === "event" && updatedFormElement.valid){
                updatedFormElement.value= ACTIVITY_LOG_SELECT_MAP[eventReceived.target.value]?ACTIVITY_LOG_SELECT_MAP[eventReceived.target.value].name:ACTIVITY_LOG_USER_EVENT_MAP[eventReceived.target.value].name 
                updatedForm.eventStatus.elementConfig.options = getStatusOptions(ACTIVITY_LOG_SELECT_MAP[eventReceived.target.value]?.value)
            }
        } else {
            updatedFormElement.valid = true;
            errorHandler(null);
        }
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        setFormIsValid(formIsValid);
        setFormInputElements(updatedForm);
    }

    const applyFilterHandler = (eventReceived) => {
        eventReceived.preventDefault()
        dispatch(setError(null))
        let formData = {...props.activityResultSearch}
        for(let formElementIdentifier in formInputElements){
            const key = formInputElements[formElementIdentifier].elementConfig.id
            const value = formInputElements[formElementIdentifier].value

            if(key === 'event' && formInputElements['event'].touched){
                formData['event'] = ACTIVITY_LOG_SELECT_MAP[value]?ACTIVITY_LOG_SELECT_MAP[value].value:ACTIVITY_LOG_USER_EVENT_MAP[value].value
            }
            else if(key === 'eventStatus'&&formInputElements['eventStatus'].touched){
                if(value === 'Select One') formData['eventStatus'] = ''
                else formData['eventStatus'] = value
            }
            else if(formInputElements[key].touched){
                if(value !== '')formData[key] = value.trim()
                else if(value !== props.activityResultSearch[key]) formData[key] = value
            }
        }
            
        formData["firstName"] = firstName.touched ? firstName.value: ''
        formData["lastName"] = lastName.touched ? lastName.value : ''
        formData["dob"] = dob.touched ? dob.value : ''
    
        props.setActivityResultSearch(formData)
        formData["page"] = 1;
        formData["pageSize"] = PAGESIZE_ACTIVITY_LOG;
        dispatch(activitySearch(formData))
        dispatch(activitySearchSetPageNumber(1))
    }

    const nextClickedEvent = (pageNo) => {
        props.activityResultSearch["page"] = pageNo
        dispatch(activitySearch(props.activityResultSearch))
    }

    const onCancelButtonClicked = () => {
        dispatch(isActivitySearched(false))
        dispatch(setError(null))
    }

    const createForm = () => {
        
        const formsElementsArray =[];

        for(let key in formInputElements) {
            formsElementsArray.push({
                id: key,
                config: formInputElements[key]
            });
        }

        let searchForm = (
            <form onSubmit={applyFilterHandler}>
                <div>
                    {formsElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            label={formElement.config.label}
                            changed={(event) => inputChangedHandler(event, formElement.id)}
                            extendedInput={formElement.config.extendedInput}
                            inputType={formElement.config.inputType}
                        />
                    ))}
                </div>
                {
                    props.eventType === 'USER' &&  <UserSearchBlock
                    firstName = {firstName}
                    lastName = {lastName}
                    dob = {dob}
                    setFirstName = {setFirstName}
                    setLastName = {setLastName}
                    setDOB = {setDOB}
                    clearSearch={clearUserSearch}
                    eventSelected = {formInputElements['event'].value}
                    errorHandler = {errorHandler}
                    formIsValid = {formIsValid}
                    setFormIsValid = {setFormIsValid}
                />
                }
                <div style={{display:'flex', justifyContent:'center'}}>
                    <Button id="cancelSearch" btnType="Cancel" clicked={clearSearch} attr={{type: "button"}}>
                        Cancel
                    </Button>
                    <Button id="activityLogResultFilter" btnType="Search" disabled={!isSearchButtonDisabled()}>Update Filters</Button>
                </div>
            </form>
        );
        
        return <div>{searchForm}</div>

    }

    const defaultSorted = [ {
        dataField: 'id',
        order: 'asc'}
    ];

    const resultColumnMapping = returnResultMapping(props.eventType);

    let searchResult = null;
    if(activities && activities.length > 0) {
        let activityListNew = getActivitiesList(props.eventType, activities)
        searchResult = !hideResult &&
            <div>
                <ReactTooltip/>
                <BootstrapTable
                    classes={classes.DataTable}
                    keyField="id"
                    data={activityListNew}
                    columns={resultColumnMapping}
                    defaultSorted={defaultSorted}
                    bordered={false}
                    hover
                    condensed
                />
                <ActivityLogPaginationBtns 
                    nextClick = {nextClickedEvent} 
                    nextDisabled = {activityList.hasNextPage}
                />
            </div>
    }

    return(
        <ActivityLogResultDisplayBox>
            <div className={classes.SearchWindow}>
                <div className={classes.Split}>
                    <h2 className={classes.FormTitle}>{formHeader}</h2>
                    <button className={classes.cancelButton} onClick={onCancelButtonClicked}>Back</button>
                </div>
                <Message msgType="Error" info={errorMsg} />
                {createForm()}
                {showSpinner?<Spinner/>:searchResult}
            </div>
        </ActivityLogResultDisplayBox>
    );
}

export default ActivityLogResults;